module.exports = __webpack_public_path__ + "static/media/modi_mask.7ac08f69.png";